import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"50px"} }, null, -1)

import { computed, ref } from "vue";
import { debug as d } from "debug";
import cms from "../../services/cms/cms";
import RenderWaiter from "../../services/utilities/render-waiter";
import {
  CmsResourceRelationship,
  CmsResourceTheme,
  CmsResourceThemesPage,
} from "../../services/cms/cms-type-definitions";
import CmsTile from "./cms-tile.vue";
import CsCarousel from "../carousels/cs-carousel.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'resource-themes-list',
  props: {
    doc: {},
    tileCssClass: { default: "" },
    cssTheme: { default: "record-sleeve-theme" }
  },
  setup(__props: any) {

const debug = d("cs.CmsThemesList");

const props = __props;

const renderWaits = ref<string[]>([]);

const renderWaiter = new RenderWaiter(renderWaits.value);

const title = computed(() => cms.asText(props.doc?.data.title));

const links = computed<CmsResourceRelationship[]>(
  () => props.doc?.data?.items?.map((i) => i.link) ?? [],
);

const contentIsLoaded = computed(() => !!props.doc && renderWaits.value.length === 0);

return (_ctx: any,_cache: any) => {
  return (contentIsLoaded.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["resource-themes-list resource-tile-carousel", _ctx.cssTheme])
      }, [
        _createElementVNode("div", {
          class: "id-anchor",
          id: title.value
        }, null, 8, _hoisted_1),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "title", {}, () => [
            _createElementVNode("h3", null, _toDisplayString(title.value), 1)
          ])
        ]),
        _createVNode(CsCarousel, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (link) => {
              return (_openBlock(), _createBlock(CmsTile, {
                key: link.id,
                class: _normalizeClass(_ctx.tileCssClass),
                link: link
              }, null, 8, ["class", "link"]))
            }), 128))
          ]),
          _: 1
        }),
        _hoisted_3
      ], 2))
    : _createCommentVNode("", true)
}
}

})